import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { sortBy, isEmpty } from 'lodash';
import { Link } from 'react-router-dom';
import { Card, AlertNotice } from 'shared/components';
import { ASSIGNMENT_STATUS } from 'shared/constants';

import './TcEvents.scss';

const TcEvents = ({ tcCycle }) => {
  const { t } = useTranslation();
  const events = sortBy(tcCycle.events, [ev => ev.testingEvent.testDate]);
  if (isEmpty(tcCycle)) {
    return null;
  }
  if (!events || !events.length) {
    return (
      <section className="tc-events-section ">
        <h5 className="mb-4">{t('testCenter.testDatesWithLengthTitle', { total: 0 })}</h5>
        <AlertNotice message={t('testCenter.noTestEventsMessage')} />
      </section>
    );
  }

  return (
    <section className="tc-events-section ">
      <h5 className="mb-4">{t('testCenter.testDatesWithLengthTitle', { total: events.length })}</h5>
      <div className="card-container">
        {events.map(event => (
          <Card small key={event.id} className="active">
            <Link
              to={`/test-event/${event.id}`}
              href={`/test-event/${event.id}`}
              className="text-pacific-blue text-strong"
              style={{ bottom: 0 }}
            >
              <div className="h-100 position-relative">
                <p className="fw-bold date-label mb-0">
                  {event.testingEvent.name}
                </p>
                <p className="manage-event-label position-absolute mb-0">
                  {event.testCenterEventStatus.toUpperCase() === ASSIGNMENT_STATUS.tested &&
                    <span className="event-completed">
                      {t('common.labels.completed')}
                      <i className="fa fa-check"></i>
                    </span>
                  }
                  {event.testCenterEventStatus.toUpperCase() === ASSIGNMENT_STATUS.closed &&
                    <span className="event-closed">
                      {t('common.labels.closed')} 
                      <i className="fa fa-exclamation-triangle"></i>
                    </span>
                  }
                  {(event.testCenterEventStatus.toUpperCase() === ASSIGNMENT_STATUS.open || event.testCenterEventStatus.toUpperCase() === ASSIGNMENT_STATUS.reschedule) &&
                    <span>{t('testCenter.manageTestDateLabel')}</span>
                  }
                </p>
              </div>
            </Link>
          </Card>
        ))}
      </div>
    </section>
  );
};

export default TcEvents;

TcEvents.propTypes = {
  tcCycle: PropTypes.shape({
    events: PropTypes.arrayOf(PropTypes.shape({})),
  }).isRequired,
};
